export default __webpack_public_path__ + "static/media/arrow-back-icon.c967edd3.svg";